import t from"../internals/to-string-tag-support.js";import r from"../internals/define-built-in.js";import o from"../internals/object-to-string.js";var i=t,e=r,n=o;i||e(Object.prototype,"toString",n,{unsafe:!0});
